import React, { useEffect, useState } from "react";
import { getFilesByNewsId } from "../../services/news";
import { Button, Card, Container, Row, Col, Form, Modal } from 'react-bootstrap';
import { deleteFileById, updateFileOrder } from '../../services/news';
import {  toast } from 'react-toastify';
import Loading from "../layout/Loading";

function FilesContainerEdit({ news_id, reloadFilesContainer, onUpdateFilesQty }) {
    const [isLoading, setIsLoading] = useState(false);
    const [files, setFiles] = useState([]);
    const [reloadFiles, setReloadFiles] = useState(false);
    const [filesQty, setFilesQty] = useState(0);
    const [preview, setPreview] = useState(null);
    const deleteFile = (id) => {
        deleteFileById(id).then(() => {
            setReloadFiles(!reloadFiles)
        })
    }

    const handleSelectChange = (e, itemId) => {
        setIsLoading(true);
        const selectedOrder = e.target.value; // Obtiene el orden seleccionado
        updateFileOrder(news_id, itemId, selectedOrder).then(() => {
            toast.success('Se actualizó correctamente');
        }).finally(() => {
            getFilesByNewsId(news_id).then((data) => {
                setFiles(data)
                setFilesQty(data.length);
                setIsLoading(false);
                onUpdateFilesQty(data.length)
            })
        })
    };

    useEffect(() => {
        setIsLoading(true);
        getFilesByNewsId(news_id).then((data) => {
            setFiles(data)
            setFilesQty(data.length);
            setIsLoading(false);
            onUpdateFilesQty(data.length)
        })
    }, [reloadFilesContainer, reloadFiles])

    return (<>
        <Container fluid className="px-0">
            <Row className="mt-2 g-2">
                {
                    isLoading ?
                        <Loading /> :
                        files.length == 0 ?
                            <p className="text-muted mt-2 mb-0">No hay archivos</p> :
                            files.map((item, index) => (
                                <Col key={index} xs={6} xl={4}>
                                    <Card className="h-100">
                                        {item.mime_type.includes("image/") ? (
                                            <div
                                                style={{ height: '110px', overflow: 'hidden', cursor: 'zoom-in' }}
                                                onClick={() => setPreview(item)}
                                                title="Clic para ampliar"
                                            >
                                                <Card.Img
                                                    variant="top"
                                                    src={item.url}
                                                    style={{ objectFit: 'cover', height: '100%', width: '100%' }}
                                                />
                                            </div>
                                        ) : item.mime_type.includes("video/") ? (
                                            <video width="100%" style={{ height: '110px', objectFit: 'cover' }} controls>
                                                <source src={item.url} type={item.mime_type} />
                                            </video>
                                        ) : null}
                                        <Card.Body className="p-2">
                                            <div className="d-flex align-items-center gap-1">
                                                <Form.Control
                                                    as="select"
                                                    size="sm"
                                                    className="flex-grow-1"
                                                    onChange={(e) => handleSelectChange(e, item.id)}
                                                >
                                                    <option value={0}>Orden</option>
                                                    {Array.from({ length: filesQty }, (_, i) => (
                                                        <option key={i} selected={item.order == (i + 1)} value={i + 1}>
                                                            {i + 1}
                                                        </option>
                                                    ))}
                                                </Form.Control>
                                                <Button variant="danger" size="sm" onClick={() => deleteFile(item.id)}>
                                                    ✕
                                                </Button>
                                            </div>
                                        </Card.Body>
                                    </Card>
                                </Col>
                            ))
                }
            </Row>
        </Container>

        {/* Modal de preview */}
        <Modal show={!!preview} onHide={() => setPreview(null)} centered size="lg">
            <Modal.Header closeButton>
                <Modal.Title style={{ fontSize: '0.95rem' }}>
                    Imagen {preview?.order} de {filesQty}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body className="p-0 text-center bg-dark">
                {preview && (
                    <img
                        src={preview.url}
                        alt={`Imagen ${preview.order}`}
                        style={{ maxWidth: '100%', maxHeight: '80vh', objectFit: 'contain' }}
                    />
                )}
            </Modal.Body>
            <Modal.Footer className="py-2 justify-content-between">
                <span className="text-muted" style={{ fontSize: '0.8rem' }}>
                    {preview?.url?.split('/').pop()}
                </span>
                <Button variant="secondary" size="sm" onClick={() => setPreview(null)}>
                    Cerrar
                </Button>
            </Modal.Footer>
        </Modal>
    </>)
}

export default FilesContainerEdit;